/**
 * 16c.5 (D-404): when the preview frame may be replaced by a reload. A new frame opens on the preview's one-time
 * link (`/.dbrain/auth?code=…`), whose answer sets the preview's cookie and goes on to the app. A reload before that
 * answer has arrived (a file the agent wrote, "Yenile") replaced the frame with the preview's root while the cookie was
 * not there yet, and the link was already used: the frame said "Sign in to Code…" for good. Such a reload waits until
 * the sign-in frame has loaded, then happens once; any other frame reloads at once, as before. DOM-free, so it is
 * tested alone.
 */
export interface FrameState {
  url: string;
  nonce: number;
}

export function isSignInFrame(url: string): boolean {
  try {
    return new URL(url).pathname === '/.dbrain/auth';
  } catch {
    return false;
  }
}

/** true: reload now; false: wait for the frame's load (it is still signing in) */
export function reloadNow(frame: FrameState | null, loadedNonce: number | null): boolean {
  if (!frame) return false;
  return !isSignInFrame(frame.url) || loadedNonce === frame.nonce;
}
